import { GameId } from '@bg-shared/enums/GameId';
import { PromotionStatus } from '@bg-shared/enums/PromotionStatus';
import { IPromotionsModel, IPromotion, IPromotionsState, IPromotionPayout } from './interfaces';

export const promotionsSelectors = {
    getPromotion: (state: IPromotionsModel, promotionId: number | null): IPromotion => {
        if (!state.promotions?.active) {
            return null;
        }

        return state.promotions.active.find((promo) => promo.id === promotionId);
    },

    getCurrentPromotion: (state: IPromotionsModel, gameId: GameId, type: string): IPromotion => {
        if (!state.promotions?.active) {
            return null;
        }

        const ACTIVE_STATUSES = [PromotionStatus.ACTIVE, PromotionStatus.PENDING_DELETED];

        // We need to return last promotion
        const typePromotions = state.promotions.active.filter(
            (promotion) =>
                promotion.enabledForGames.includes(gameId) &&
                ACTIVE_STATUSES.includes(promotion.status) &&
                promotion.type.toLowerCase().replace(/\s+/g, '') === type,
        );

        const activePromotion = typePromotions.find((promo) => !promo.wonAt);

        if (activePromotion) {
            return activePromotion;
        }

        if (!typePromotions.length) {
            return null;
        }

        // return last won promotion
        return typePromotions.reduce((prev, next) => (prev.wonAt > next.wonAt ? prev : next));
    },

    getPromotionsRates: (state: IPromotionsModel): IPromotionsState['currencyRates'] => {
        if (!state.promotions?.active) {
            return null;
        }

        return state.promotions.currencyRates;
    },

    getPromotionPayout: (state: IPromotionsModel, gameId: GameId): IPromotionPayout => {
        if (!state.promotionPayouts?.length) {
            return null;
        }

        const gamePayouts = state.promotionPayouts.filter((payout) =>
            payout.enabledForGames.includes(gameId),
        );

        return gamePayouts.length ? gamePayouts[gamePayouts.length - 1] : null;
    },
};
